import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { SiteCreditBalance } from '../models/siteCreditBalance.model';

@Injectable({
    providedIn: 'root'
})
export class SiteCreditBalanceService extends GridService<SiteCreditBalance> {

    constructor(http: HttpClient) {
        super('SiteCreditBalance', http);
    }
}
